import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

import { format } from "date-fns";
import { fr } from "date-fns/locale";
//import { formatInTimeZone } from 'date-fns-tz'


// flatpickr
import "flatpickr/dist/themes/material_blue.css";
//import FlatPickr from "react-flatpickr";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';
import SearchPreRegistration from "./partials/SearchPreRegistration";

import {
    getPreRegistrations as onGetPreRegistrations,
    addNewPreRegistration as onAddNewPreRegistration,
    updatePreRegistration as onUpdatePreRegistration,
    deletePreRegistration as onDeletePreRegistration,
    setSelectedPreRegistration as onSetSelectedPreRegistration,

} from "store/actions";

//import { setSelectedPreRegistration } from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,Collapse,
} from "reactstrap";



//import { Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row, Label, Input, Form, Collapse, FormFeedback } from 'reactstrap';

import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";


const PreRegistrationStatus = ({ status }) => {
  switch (status) {
    case "En attente":
      return <Badge className="bg-warning"> {status} </Badge>;

    case "Rejetée":
      return <Badge className="bg-danger"> {status} </Badge>;

    case "Validée":
      return <Badge className="bg-success"> {status} </Badge>;

    default:
      return <Badge className="bg-success"> {status} </Badge>;
  }
};

const PreRegistration = () => {

    //meta title
    document.title = "Préinscriptions | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [student, setStudent] = useState(null);


    const dateChange = (date) => {
        setSelectDate(date);
    };
    const [isOpen, setIsOpen] = useState(false);
    //const toggle = () => setIsOpen(!isOpen);
    const experienceData = [];
    const jobType = [];

    


 

   

    const dispatch = useDispatch();

    const PreRegistrationProperties = createSelector(
        (state) => state.preRegistrationReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (preRegistrationReducer) => ({
            preRegistrations: preRegistrationReducer.preRegistrations,
            loading: preRegistrationReducer.loading
        })
    );

    const {preRegistrations, loading} = useSelector(PreRegistrationProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (preRegistrations && !preRegistrations.length) {
            dispatch(onGetPreRegistrations());
        }
    }, [dispatch, preRegistrations.length]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setStudent(null);
        } else {
            setModal(true);
        }
    };

    const handleStudentClick = arg => {
        const student = arg;
        setStudent({
            id: student.id,
            uuid: student.uuid,
            first_name: student.first_name,
            last_name: student.last_name,
            civility: student.civility,
            matricule: student.matricule,
            phone: student.phone,
            
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (student) => {
        setStudent(student);
        setDeleteModal(true);
    };

    const handleDeletePreRegistration = () => {
        if (student && student.id) {
            
            dispatch(onDeletePreRegistration(student));
            setDeleteModal(false);
        }
    };

    // Search
    const handleSearch = (filters) => {
        dispatch(onGetPreRegistrations(filters));
    };

   

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Date",
                accessorKey: "created_at",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const dateStr = cellProps.row.original.created_at;
                    return format(dateStr, "dd/MM/yyyy", { locale: fr }); 
                },
                
            },
            {
                header: "Matricule CNOU",
                accessorKey: "cnou_registration_number",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Prénom",
                accessorKey: "first_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Nom",
                accessorKey: "last_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Genre",
                accessorKey: "sex",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Téléphone",
                accessorKey: "phone",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Lieu de residence",
                accessorKey: "residence_place",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Statut",
                accessorKey: "status",
                cell: (cellProps) => <PreRegistrationStatus status={cellProps.row.original.status} />,
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            <li>
                                <Link 
                                    //to="/pre-registration-details" 
                                    to={`/pre-registration/${cellProps.row.original.uuid}/details`}
                                    className="btn btn-sm btn-soft-primary" 
                                    //onClick={() => dispatch(onSetSelectedPreRegistration(cellProps.row.original))}
                                    id={`viewtooltip${cellProps.row.original.id}`}>

                                <i className="mdi mdi-eye-outline" />
                                <UncontrolledTooltip placement="top" target={`viewtooltip${cellProps.row.original.id}`}>
                                    Apperçu
                                </UncontrolledTooltip>
                                </Link>
                            </li>
                            {/*
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleStudentClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>*/}

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeletePreRegistration}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Préinscriptions" breadcrumbItem="Liste des préinscriptions" />
                   <SearchPreRegistration onSearch={handleSearch} />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                   {/* <Link to="#!" onClick={onClickNewStudent} className="btn btn-primary me-1">Ajouter un étudiant</Link> */}
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={preRegistrations || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={false}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default PreRegistration;